import React, { useState, useEffect } from "react";
import styled from 'styled-components';
import ArticleCard from './ArticleCard';
import { colors, mediaQueries } from "../shared/config";

const Grid = styled.div`
display: grid;
grid-template-columns: repeat(2, 1fr);
grid-gap: 20px;
margin-bottom: 20px;
${mediaQueries.mobile} {
    grid-template-columns: repeat(1, 1fr);
}
`;

const TitleGrid = styled.div`
  display: grid; 
  grid-template-columns: repeat(2,1fr);
  /* border: 1px solid black; */
  padding-bottom: 15px;
  grid-gap: 20px;
`;

const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    background: ${colors.background};
    padding: 0.2em 0;
    justify-content: space-around;
    padding: 1% 10% 0% 10%;
    ${mediaQueries.mobile} {
        padding: 1% 5% 0% 5%;
    }
`;

const Title = styled.div`
    font-family: 'Press Start 2P', cursive;
    /* -webkit-text-stroke: 1px white;  */
    font-size: 20px;
    text-shadow:
            1px 1px 0 #fff, -1px 1px 0 #fff, 1px -1px 0 #fff, -1px -1px 0 #fff,
            0px 1px 0 #fff, 0px -1px 0 #fff, -1px 0px 0 #fff, 1px 0px 0 #fff,
            2px 2px 0 #fff, -2px 2px 0 #fff, 2px -2px 0 #fff, -2px -2px 0 #fff,
            0px 2px 0 #fff, 0px -2px 0 #fff, -2px 0px 0 #fff, 2px 0px 0 #fff,
            1px 2px 0 #fff, -1px 2px 0 #fff, 1px -2px 0 #fff, -1px -2px 0 #fff,
            2px 1px 0 #fff, -2px 1px 0 #fff, 2px -1px 0 #fff, -2px -1px 0 #fff;
`;

const DB_TextBox = styled.div`
    /* border: 1px solid black; */
    display: flex;
    justify-content: center;
    align-items: center;
    /* box-shadow: 0 3px 10px rgb(0 0 0 / 0.2); */
    //how to make a semi-transparent background
    background-image: linear-gradient(to bottom, #ffffff00 50%, #0C6498 50%); 
    //#fffffff00 is transparent
`;

const DT_TextBox = styled.div`
    /* border: 1px solid black; */
    display: flex;
    justify-content: center;
    align-items: center;
    /* box-shadow: 0 3px 10px rgb(0 0 0 / 0.2); */
    background-image: linear-gradient(to bottom, #ffffff00 50%, #C31F1F 50%);
`


export default function ArticleGrid(props) {
    let allData = props.data;
    

    return (
        <Wrapper>
            <Grid>
                { allData && allData.map((card,index)=> { console.log("dataaaa"); console.log(card);
                    return <ArticleCard author = {card.byline} text = {card.title} url = {card.article_link} image = {card.image_link}/>}
                )}
            </Grid>
        </Wrapper>
    );
}